import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-002edec3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "all-menu-content" }
const _hoisted_2 = { class: "menu-left" }
const _hoisted_3 = { class: "search-input" }
const _hoisted_4 = { class: "recently" }
const _hoisted_5 = { class: "menu-title" }
const _hoisted_6 = { class: "recently-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "all-menu" }
const _hoisted_9 = {
  class: "menu-title",
  style: {"margin-bottom":"20px"}
}
const _hoisted_10 = { class: "all-menu-list" }
const _hoisted_11 = { class: "menu-title" }
const _hoisted_12 = { class: "item-list" }
const _hoisted_13 = ["onClick"]


import { ref, computed, defineEmits, defineProps, inject, watch } from 'vue'
import { Check, Close } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { getCollectMenuList, batchCollect, getUserMenuList } from '@/services/user'

const __default__ = {
  name: 'AllMenuContent'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isShow: {
    default: false,
    type: Boolean
  }
},
  emits: ['close'],
  setup(__props, { emit: emits }) {

const props = __props

const $t: any = inject('$t')




watch(
  () => props.isShow,
  (val) => {
    if (val) {
      getList()
    }
  }
)

const router = useRouter()
const store = useStore()
const searchMenu = ref('')
const allMenuList = ref<any[]>([])
const allList = ref<any[]>([])
const recentVisitList = computed(() => {
  return store.state.menu.recentVisitList
})

const parseLang = (list: any[]) => {
  return list.map(item => {
    return {
      ...item,
      menuList: item.menuList.map((menu: any) => { return { ...menu, menuName: $t(menu.menuName) } })
    }
  })
}

const getList = async () => {
  try {
    const { data } = await getCollectMenuList()
    allMenuList.value = parseLang(data.collectList)
    allList.value = allMenuList.value
  } catch (error) {
    console.log(error)
  }
}

const handleClose = () => {
  emits('close')
}

const handleCollect = async (subItem: any) => {
  try {
    const { collect, menuId } = subItem
    await batchCollect([{ menuId, collect }])
    getMenuList()
  } catch (error) {
    console.log(error)
  }
}

const getMenuList = async () => {
  try {
    const { data } = await getUserMenuList()
    store.commit('menu/setMenuList', data.menuList)
  } catch (error) {
    console.log(error)
  }
}

const toPage = (route: string) => {
  if (route) {
    handleClose()
    router.push(route)
  }
}

const handleSearchMenu = (val: string) => {
  if (val === '') {
    allMenuList.value = allList.value
    return
  }
  const list: any[] = []
  allList.value.forEach(item => {
    const hasMenuList = item.menuList.filter((menu: any) => {
      return menu.menuName.indexOf(val) !== -1
    })
    if (hasMenuList.length > 0) {
      list.push({
        ...item,
        menuList: hasMenuList
      })
    }
  })
  allMenuList.value = list
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_collapse_transition = _resolveComponent("el-collapse-transition")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_collapse_transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_input, {
                clearable: "",
                modelValue: searchMenu.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchMenu).value = $event)),
                placeholder: _unref($t)('main_header_placeholder'),
                onInput: handleSearchMenu
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref($t)('main_header_recent_visit')), 1),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recentVisitList), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "menu-item",
                    key: item.routeUrl,
                    onClick: ($event: any) => (toPage(item.routeUrl))
                  }, _toDisplayString(_unref($t)(item.name)), 9, _hoisted_7))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref($t)('main_menu_bar_management')), 1),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allMenuList.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.systemName,
                    class: "item"
                  }, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.systemName), 1),
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.menuList, (subItem) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: subItem.menuId,
                          class: "menu-item",
                          onClick: ($event: any) => (toPage(subItem.menuRouteUrl))
                        }, [
                          _createTextVNode(_toDisplayString(_unref($t)(subItem.menuName)) + " ", 1),
                          _createElementVNode("div", {
                            class: "colect-content",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createVNode(_component_el_switch, {
                              modelValue: subItem.collect,
                              "onUpdate:modelValue": ($event: any) => ((subItem.collect) = $event),
                              "inline-prompt": "",
                              "active-icon": _unref(Check),
                              "inactive-icon": _unref(Close),
                              onChange: ($event: any) => (handleCollect(subItem))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "active-icon", "inactive-icon", "onChange"])
                          ])
                        ], 8, _hoisted_13))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ], 512), [
          [_vShow, props.isShow]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "el-fade-in-linear" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "menu-shadow",
          onClick: handleClose
        }, null, 512), [
          [_vShow, props.isShow]
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})